import { Keypair } from '@solana/web3.js';
import * as bip39 from 'bip39';
import * as ed25519 from 'ed25519-hd-key';
import bs58 from 'bs58';
import * as Form from './form';

const DERIVATION_PATH = "m/44'/501'/0'/0'";

interface WalletGeneratorProps {
    onPrivateKeyChange: (key: string) => void;
}

export default function SolWalletGenerator({ onPrivateKeyChange }: WalletGeneratorProps) {
    const generateWallet = async () => {
        const mnemonic = bip39.generateMnemonic();
        const seed = await bip39.mnemonicToSeed(mnemonic);
        const derivedSeed = ed25519.derivePath(DERIVATION_PATH, seed.toString('hex')).key;
        const keypair = Keypair.fromSeed(Uint8Array.from(derivedSeed));

        const pubkey = keypair.publicKey.toBase58();
        const privkey = bs58.encode(keypair.secretKey);

        onPrivateKeyChange(privkey);

        const rows = ['Public Key,Private Key (base58),Seed Phrase', `${pubkey},${privkey},${mnemonic}`];
        const csvContent = rows.join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${pubkey}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    //return <Form onClick={generateWallet}>Generate Wallet</Form>;
    return (
        <Form.Button className='w-[69px] h-[34px] text-[14px] text-ash-grey font-bold' onClick={generateWallet}>
            Generate
        </Form.Button>
    );
}
